import template from './mobile_app.all.html';
import controller from './mobile_app.all.controller';
import './mobile_app.all.scss';

let mobileAppAllComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },

    template,
    controller
};

export default mobileAppAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/all/mobile_app.all.component.js